import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";

import Checkbox from "@material-ui/core/Checkbox";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex"
  },
  formControl: {
    marginLeft: theme.spacing(0)
  }
}));

const FilterState = props => {
  const { stateFilter, expandView, resetComponent } = props;

  const classes = useStyles();
  const [state, setState] = useState({
    CA: false,
    DE: false,
    DC: false,
    FL: false,
    GA: false,
    IN: false,
    KS: false,
    KY: false,
    MA: false,
    MN: false,
    LA: false,
    MI: false,
    MS: false,
    NV: false,
    NJ: false,
    NC: false,
    MD: false,
    NY: false,
    OH: false,
    OK: false,
    OR: false,
    PA: false,
    TX: false
  });

  const handleChange = event => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  useEffect(() => {
    if (resetComponent) {
      setState({
        CA: false,
        DE: false,
        DC: false,
        FL: false,
        GA: false,
        IN: false,
        KS: false,
        KY: false,
        MA: false,
        MN: false,
        LA: false,
        MS: false,
        NV: false,
        NJ: false,
        NC: false,
        MD: false,
        NY: false,
        NO: false,
        OK: false,
        OR: false,
        PA: false,
        TX: false
      });
    }
  }, [resetComponent]);

  useEffect(() => {
    //console.log(state);
    stateFilter(state);
  }, [state]);

  const {
    CA,
    CT,
    DC,
    DE,
    FL,
    GA,
    IN,
    KS,
    KY,
    LA,
    MD,
    MN,
    MS,
    NJ,
    NV,
    NY,
    NC,
    OH,
    OK,
    OR,
    PA,
    TX
  } = state;

  return (
    <div>
      <div className={classes.root}>
        <FormControl component="fieldset" className={classes.formControl}>
          {" "}
          {expandView ? (
            <FormLabel component="legend"> STATE </FormLabel>
          ) : null}
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox checked={CA} onChange={handleChange} name="CA" />
              }
              label="California"
            />

            <FormControlLabel
              control={
                <Checkbox checked={CT} onChange={handleChange} name="CT" />
              }
              label="Connecticut"
            />

            <FormControlLabel
              control={
                <Checkbox checked={DE} onChange={handleChange} name="DE" />
              }
              label="Delaware"
            />

            <FormControlLabel
              control={
                <Checkbox checked={FL} onChange={handleChange} name="FL" />
              }
              label="Florida"
            />

            <FormControlLabel
              control={
                <Checkbox checked={GA} onChange={handleChange} name="GA" />
              }
              label="Georgia"
            />

            <FormControlLabel
              control={
                <Checkbox checked={IN} onChange={handleChange} name="IN" />
              }
              label="Indiana"
            />

            <FormControlLabel
              control={
                <Checkbox checked={KS} onChange={handleChange} name="KS" />
              }
              label="Kansas"
            />

            <FormControlLabel
              control={
                <Checkbox checked={KY} onChange={handleChange} name="KY" />
              }
              label="Kentucky"
            />

            <FormControlLabel
              control={
                <Checkbox checked={LA} onChange={handleChange} name="LA" />
              }
              label="Louisiana"
            />

            <FormControlLabel
              control={
                <Checkbox checked={MD} onChange={handleChange} name="MD" />
              }
              label="Maryland"
            />

            <FormControlLabel
              control={
                <Checkbox checked={MN} onChange={handleChange} name="MN" />
              }
              label="Minnesota"
            />

            <FormControlLabel
              control={
                <Checkbox checked={MS} onChange={handleChange} name="MS" />
              }
              label="Mississippi"
            />

            <FormControlLabel
              control={
                <Checkbox checked={NV} onChange={handleChange} name="NV" />
              }
              label="Nevada"
            />

            <FormControlLabel
              control={
                <Checkbox checked={NJ} onChange={handleChange} name="NJ" />
              }
              label="New Jersey"
            />

            <FormControlLabel
              control={
                <Checkbox checked={NY} onChange={handleChange} name="NY" />
              }
              label="New York"
            />

            <FormControlLabel
              control={
                <Checkbox checked={NC} onChange={handleChange} name="NC" />
              }
              label="North Carolina"
            />

            <FormControlLabel
              control={
                <Checkbox checked={OH} onChange={handleChange} name="OH" />
              }
              label="Ohio"
            />

            <FormControlLabel
              control={
                <Checkbox checked={OK} onChange={handleChange} name="OK" />
              }
              label="Oklahoma"
            />

            <FormControlLabel
              control={
                <Checkbox checked={OR} onChange={handleChange} name="OR" />
              }
              label="Oregon"
            />

            <FormControlLabel
              control={
                <Checkbox checked={PA} onChange={handleChange} name="PA" />
              }
              label="Pennsylvania"
            />

            <FormControlLabel
              control={
                <Checkbox checked={TX} onChange={handleChange} name="TX" />
              }
              label="Texas"
            />

            <FormControlLabel
              control={
                <Checkbox checked={DC} onChange={handleChange} name="DC" />
              }
              label="Washington DC"
            />
          </FormGroup>{" "}
        </FormControl>{" "}
      </div>{" "}
    </div>
  );
};
export default FilterState;
